import axiosInstance from "../plugins/axios-plugin";

export default {
  namespaced: true,
  state: {
    _id: null,
    path: null,
    email: null,
    user_agent: null,
    created_at: null,
    request_ip: null
  },
  getters: {
    isLocked: (state, getters, rootState, rootGetters) => {
      return typeof state.email === 'string' && state.email !== rootGetters["auth/user"].email
    },
    editorData: state => state
  },
  actions: {
    check: async ({ dispatch, commit }, payload) => {
      try {
        const { data } = await axiosInstance.get('/editors', {
          params: {
            path: payload.path
          }
        })

        if (data.editor) {
          commit('setData', data.editor)
        } else {
          await dispatch('register', payload)
        }
      } catch (error) {
        console.log(error)
      }
    },

    register: async ({ commit }, payload) => {
      try {
        const { data } = await axiosInstance.post('/editors', {
          path: payload.path
        })

        commit('setData', data.editor)
      } catch (error) {
        console.log(error)
      }
    },

    remove: async ({ commit, getters }, payload) => {
      const makeRequest = !getters.isLocked || (payload && payload.override === true)

      if(makeRequest) {
        try {
          await axiosInstance.delete(`/editors/${getters.editorData._id}`)
          commit('resetData')
        } catch (error) {
          console.log(error)
        }
      } else {
        commit('resetData')
      }
    },
  },
  mutations: {
    setData: (state, payload) => {
      state._id = payload._id
      state.path = payload.path
      state.email = payload.email
      state.created_at = payload.created_at
      state.user_agent = payload.user_agent
      state.request_ip = payload.request_ip
    },
    resetData: (state, payload) => {
      state._id = null
      state.path = null
      state.created_at = null
      state.email = null
      state.user_agent = null
      state.request_ip = null
    }
  },
}
